import { render, staticRenderFns } from "./FireNumberOfExternalDamages.vue?vue&type=template&id=4852f22e&scoped=true"
import script from "./FireNumberOfExternalDamages.vue?vue&type=script&lang=ts"
export * from "./FireNumberOfExternalDamages.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4852f22e",
  null
  
)

export default component.exports